<template>
    <b-tab title="Usuários">
        <user-management v-if="canManageUsers" />
        <users-last-logins v-if="canViewLastLogins" />
    </b-tab>
</template>

<script>
import UserManagement from "./common/UserManagement";
import UsersLastLogins from "./common/UsersLastLogins";

export default {
    name: "UsersTab",
    components: {
        UserManagement,
        UsersLastLogins
    },
    props: {
        permissions: {
            type: Array,
            required: true
        }
    },
    computed: {
        canManageUsers() {
            return this.permissions.includes("simbar.core.manage_users");
        },
        canViewLastLogins() {
            return this.permissions.includes("simbar.core.view_last_logins");
        }
    }
};
</script>
